import { Injectable, isDevMode } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from 'src/environments/environment';
import { version } from '../../../package.json';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  currentEnv = environment.name;

  initialize(): void {
    if (isDevMode() || this.currentEnv === 'development') {
      return;
    }

    datadogLogs.init({
      clientToken: 'pub13af3461db02780fe7e2c6d061ac6ab2',
      site: 'datadoghq.com',
      service: 'store-ui',
      env: this.currentEnv,
      version,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      trackSessionAcrossSubdomains: true,
    });
  }
}
